export function isMac() {
  return window.navigator.platform.includes('Mac');
}

export function isPC() {
  return window.navigator.platform.includes('Win');
}
